import { Image, Text, StyleSheet, Document, Page } from "@react-pdf/renderer";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface IStrengthsDemoPdf {
    selectedStrengthsDemo?: any[];
}

const StrengthsDemoPdf: FC<IStrengthsDemoPdf> = ({selectedStrengthsDemo}) => {
    const { t } = useTranslation();

    const styles = StyleSheet.create({
        body: {
            paddingTop: 35,
            paddingBottom: 65,
            paddingHorizontal: 35,
            backgroundColor: "#005776",
        },
        logoImage: {
            width: 120,
            left: 200,
            paddingBottom: 20
        },
        title: {
            fontSize: 16,
            margin: "20 0 30 0",
            color: "#fff",
            textAlign: "center",
        },
        strText: {
            fontSize: 13,
            width: 150,
            top: 80,
            color: '#005776',
            textAlign: "center",
            position: "absolute",
            padding: '0 20',
            fontWeight: 800,
        },
        infoText: {
            fontSize: 10,
            width: 150,
            top: 110,
            color: '#005776',
            textAlign: "center",
            position: "absolute",
            padding: '0 20',
            fontWeight: 600,
        },
        displayInRow: {
            width: 500,
            left: 20,
            height: 200,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            margin: "20 0"
        },
        strImage: {
            margin: "0 10",
        },
    });
      
    if(selectedStrengthsDemo?.length !== 5)
        return(
            <Document>
                <Page style={styles.body}>
                    <Text style={styles.title}> {t("somethingWentWrongText")} </Text>
                </Page>
            </Document>  
        )

    return (
        <Document>
            <Page style={styles.body}>

                <Image
                    style={styles.logoImage}
                    src="https://i.postimg.cc/kXLy2dH0/LogoPDF.png"
                />  

                <Text style={styles.title}> {t("5StrengthsThatYouSelectedText")} </Text>
                
                <div style={styles.displayInRow}>
                    <div style={styles.strImage} >
                        <Image src="https://i.postimg.cc/3RMqHvXc/Strength.png" />
                        <Text style={styles.strText}> {selectedStrengthsDemo[0]?.description} </Text>
                        <Text style={styles.infoText}> {selectedStrengthsDemo[0]?.info} </Text>
                    </div>  
                    <div style={styles.strImage} >
                        <Image src="https://i.postimg.cc/3RMqHvXc/Strength.png" />
                        <Text style={styles.strText}> {selectedStrengthsDemo[1]?.description} </Text>
                        <Text style={styles.infoText}> {selectedStrengthsDemo[1]?.info} </Text>
                    </div>  
                    <div style={styles.strImage} >
                        <Image src="https://i.postimg.cc/3RMqHvXc/Strength.png" />
                        <Text style={styles.strText}> {selectedStrengthsDemo[2]?.description} </Text>
                        <Text style={styles.infoText}> {selectedStrengthsDemo[2]?.info} </Text>
                    </div>   
                </div>

                <div style={styles.displayInRow}>
                    <div style={styles.strImage} >
                        <Image src="https://i.postimg.cc/3RMqHvXc/Strength.png" />
                        <Text style={styles.strText}> {selectedStrengthsDemo[3]?.description} </Text>
                        <Text style={styles.infoText}> {selectedStrengthsDemo[3]?.info} </Text>
                    </div>  
                    <div style={styles.strImage} >
                        <Image src="https://i.postimg.cc/3RMqHvXc/Strength.png" />
                        <Text style={styles.strText}> {selectedStrengthsDemo[4]?.description} </Text>
                        <Text style={styles.infoText}> {selectedStrengthsDemo[4]?.info} </Text>
                    </div>   
                </div>
                
                </Page>
        </Document>
    );
};

export default StrengthsDemoPdf;
